var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReachedPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.379,
    height: 21.97,
    viewBox: "0 0 15.379 21.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M15.189,3A7.684,7.684,0,0,0,7.5,10.689c0,5.767,7.689,14.28,7.689,14.28s7.689-8.513,7.689-14.28A7.684,7.684,0,0,0,15.189,3Zm0,10.436a2.746,2.746,0,1,1,2.746-2.746A2.747,2.747,0,0,1,15.189,13.436Z",
    transform: "translate(-7.5 -3)",
    fill: "#5650ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachedPickup);
export default __webpack_public_path__ + "static/media/reached_pickup.8b59fd6efcf6abcdabc80fa116cc369d.svg";
export { ForwardRef as ReactComponent };